// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"661bdc78","36":"dab116dc","38":"8444f6ce","93":"524e2db5","133":"04a954bd","213":"67fd2f1c","223":"02dc137d","372":"4290a784","394":"8fc5a739","438":"0b4bd6c7","634":"8c6cd5e3","801":"ad3b9532","929":"500ea43c"}[chunkId] + ".chunk.js";
};